import React from 'react'
import { Label,Input} from "reactstrap";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { Grid, Typography, Button, Box,Container,TextField } from '@mui/material';
import { useGetDeliveryCheckQuery,useSendDeliveredDocMutation, useGetDeliveryAllDocumentsQuery,
} from './ProcurementApiSlice';
import { DeliveryAllDoc } from './DeliveryAllDoc';
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
const DeliveryDocs = ({ FullList, user_id, handleClose, refetch, AddResponse, refetchAddResponse }) => {
  let ProcCode = FullList.ProcCode;
  const { data: dropdownData, isLoading, refetch: refetchDropdown } = useGetDeliveryCheckQuery(ProcCode,{refetchOnMountOrArgChange:true});
  // const {
  //   data: AddResponse,
  //   refetch: refetchAddResponse,
  // } = useGetDeliveryAllDocumentsQuery(ProcCode);
  const [delivered] = useSendDeliveredDocMutation();
  // const [updatedList, setUpdatedList] = useState([]);
  // const [updatedListBuyer, setupdatedListBuyer] = useState([]);
  const [dispatchRecords, setdispatchRecords] = useState([]);
  const [formData, setFormData] = useState({
    quantity: '',
    weighbridge: '',
    goods_receiving_note: '',
    quality_sheet: '',
    remarks: '',
  });

  const [loading, setLoading] = useState(false);
  const [selectedQuantity, setSelectedQuantity] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState('');

  useEffect(() => {
    if (dropdownData !== undefined) {
      setdispatchRecords(dropdownData?.data);
    }
  }, [dropdownData]);

  const handleFormSubmit = event => {
    event.preventDefault();
    setLoading(true);
    const formPayload = new FormData();
    formPayload.append('entity_type', 'Buyer');
    formPayload.append('user_id', user_id);
    formPayload.append('weightbridge_slip', formData.weighbridge);
    formPayload.append('goods_receiving_note', formData.goods_receiving_note);
    formPayload.append('quality_sheet', formData.quality_sheet);
    formPayload.append('quantity', formData.quantity?formData.quantity:selectedQuantity);
    formPayload.append('category', 'Procurement');
    formPayload.append('ProcCode',ProcCode);
    formPayload.append('remark', formData.remarks);
    formPayload.append("dispatch_record",selectedId)
    delivered(formPayload)
      .unwrap()
      .then(data => {
        toast.success('Document Uploaded Successfully !!');
        setFormData({
          quantity: '',
          weighbridge: '',
          goods_receiving_note: '',
          quality_sheet: '',
          remarks: '',
        })
        setSelectedQuantity("")
        setLoading(false);
        refetch();
        refetchAddResponse()
        refetchDropdown()
      })
      .catch(data => {
        toast.error(`${data.data.message}`);
        setLoading(false);
      });
  };

  
  const handleQuantityChange = (e) => {
    const selectedQty = e.target.value;
    setSelectedQuantity(selectedQty);
  
    const selectedId = e.target.selectedOptions[0].getAttribute('data-id');
    setSelectedId(selectedId);
    
    console.log("selectedId", selectedId);
  
    const selectedRecord = dispatchRecords.find(record => record.id === selectedId);
    
    console.log("selectedRecord", selectedRecord);
  
    setFilteredDocuments(selectedRecord ? selectedRecord.documents : []);
  };

  const handleChange = (field, event) => {
    const { type, value, files } = event.target;
    if (type === 'file') {
      // Assuming setFormData is defined elsewhere
      setFormData(prevData => ({
        ...prevData,
        [field]: files[0],
      }));
    } else {
      if (field === 'quantity') {
        setSelectedQuantity(value); // Update selectedQuantity when input changes
      }
      setFormData(prevData => ({
        ...prevData,
        [field]: value,
      }));
    }
  };
  return (
    <>
      <div>
        <Container maxWidth="lg" sx={{ bgcolor: '#f5f5f5', borderRadius: 2 }}>
          <Grid container direction="column" spacing={3} mt={2}>
            <Grid item xs={12}>
          
                  {AddResponse?.data[0]?.status==="Delivered" ?"":

              <form onSubmit={handleFormSubmit} className='mb-4'>
                <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
        <Typography variant="subtitle1" className="text-primary text-underline">
          Select Quantity
        </Typography>
        <label>
          (For marking Delivered) <span className="checkingcss">*</span>
        </label>
        <Input
          type="select"
          // value={selectedQuantity}
          onChange={handleQuantityChange}
          required
          sx={{ fontSize: '15px' }}
          className="mt-1 p-2"
        >
          <option value="">Select Quantity</option>
  {dispatchRecords
    ?.filter(record => !record.is_delivered) 
    .map(record => (
      <option key={record.stock_location.id} value={record.quantity} data-id={record.id}>
        {record.quantity} ({record.stock_location.address}, {record.stock_location.district})
      </option>
    ))}
        </Input>
        <Grid container spacing={2} justifyContent="flex-start" alignItems="flex-start">
          {filteredDocuments?.map((document) => (
            <Grid item xs={6} sm={4} md={3} key={document.id} className='mt-3 mx-3'>
              <a href={document.file} target="_blank" rel="noopener noreferrer">
                <Box
                  sx={{
                    width: '100%',
                    height: 40,
                    backgroundImage: 'url(https://images.pexels.com/photos/1526/dark-blur-blurred-gradient.jpg)', // Random blurred image
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    cursor: 'pointer',
                    filter: 'blur(2px)',
                    '&:hover': {
                      filter: 'none',
                    },
                  }}
                />
              </a>
              <Typography align="center" variant="body2" sx={{ mt: 1 }}>
                {document.pattern}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="subtitle1" className="text-primary text-underline">
          Quantity
        </Typography>
        <label>
          (For marking Delivered) <span className="checkingcss">*</span>
        </label>
        <Input
          type="text"
          value={selectedQuantity}
          onChange={e => handleChange('quantity', e)}
          required
          sx={{ fontSize: '15px' }}
        />
      </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="subtitle1" className="text-primary text-underline">
                      Upload Weighbridge Slip
                    </Typography>
                    <Label>
                      (PDF format only) <span className="checkingcss">*</span>
                    </Label>
                    <Input
                      type="file"
                      accept=".pdf"
                      onChange={e => handleChange('weighbridge', e)}
                      required
                      sx={{ fontSize: '15px' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="subtitle1" className="text-primary text-underline">
                      Upload Goods Receiving Note
                    </Typography>
                    <Label>(PDF format only) <span className="checkingcss">*</span></Label>
                    <Input
                      type="file"
                      accept=".pdf"
                      required
                      onChange={e => handleChange('goods_receiving_note', e)}
                      sx={{ fontSize: '15px' }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <Typography variant="subtitle1" className="text-primary text-underline">
                      Upload Quality Sheet
                    </Typography>
                    <Label>(PDF format only)</Label>
                    <Input
                      type="file"
                      accept=".pdf"
                      onChange={e => handleChange('quality_sheet', e)}
                      sx={{ fontSize: '15px' }}
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <Typography variant="subtitle1" className="text-primary">
                      Remarks 
                    </Typography>
                    <TextField
                      placeholder="Type your remarks here"
                      multiline
                      rows={2}
                      className='bgWhite'
                      fullWidth
                      sx={{ fontSize: '15px' }}
                      value={formData.remarks}
                      onChange={e => handleChange('remarks', e)}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button type="submit" variant="contained" color="primary" disabled={loading}>
                      Submit
                    </Button>
                    <Button type="button" variant="outlined" color="secondary" onClick={handleClose} className='mx-2'>
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </form>
              }
             <DeliveryAllDoc procCode={ ProcCode} user_id={user_id} refetch={refetch} FullList={FullList} AddResponse={AddResponse}
                refetchAddResponse={refetchAddResponse}/> 
      
            </Grid>
          </Grid>

          {lightboxOpen && 
            <Lightbox image={lightboxImage} title="Image Title" onClose={() => setLightboxOpen(false)} />
           }
         
        </Container>
      </div>
    </>
  );
};

export default DeliveryDocs;
